import {
  UPDATE_ADMIN_FORM,
  UPDATE_ADMIN_FORM_ERROR,
  UPDATE_MD_FORM,
  UPDATE_MD_FORM_ERROR,
} from "../actions/formActions";

const initialState = {
  adminForm: {},
  adminFormErrors: {},
  mdForm: {
    title: "Medical Director",
  },
  mdFormErrors: {},
};

const formReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ADMIN_FORM:
      return {
        ...state,
        adminForm: {
          ...state.adminForm,
          [action.payload.key]: action.payload.value,
        },
      };
    case UPDATE_MD_FORM:
      return {
        ...state,
        mdForm: {
          ...state.mdForm,
          [action.payload.key]: action.payload.value,
        },
      };
    case UPDATE_ADMIN_FORM_ERROR:
      return {
        ...state,
        adminFormErrors: {
          ...state.adminFormErrors,
          [action.payload.key]: action.payload.value,
        },
      };
    case UPDATE_MD_FORM_ERROR:
      return {
        ...state,
        mdFormErrors: {
          ...state.mdFormErrors,
          [action.payload.key]: action.payload.value,
        },
      };
    default:
      return state;
  }
};

export default formReducer;
